export const SIDEBAR_TABS = {
  HOME: 'home',
  ACTIVITY: 'activity',
  MESSAGES: 'messages',
  NOTIFICATIONS: 'notifications',
  SETTINGS: 'settings',
  CREATORS: 'creators',
  MONETIZE: 'monetize',
  WALLET: 'wallet',
  INSIGHTS: 'insights',
  RESOURCES: 'resources',
  CREATE_ON_TOPFANS: 'create_on_topfans',
  PROFILE: 'profile',
  WELCOME_MESSAGE: 'welcome_message',
  INTERESTS: 'interests',
  CREATOR_TYPE: 'creator_type',
  TOPIC_TAGS: 'topic_tags',
  BADGES: 'badges',
  DELEGATION: 'delegation',
  NFT_WALLET: 'nft_wallet',
  PRIVACY_AND_PASSWORD: 'privacy_and_password',
  MONETIZATION: 'monetization',
  OUTBOUND_EMAILS: 'outbound_emails',
  LINK_IN_BIO: 'link_in_bio',
  WHITE_LABELED_SITE: 'white_labeled_site',
  SEARCH: 'search',
  GAMIFICATION: 'gamification',
  PROFILE_NAV: 'profile_nav',
  PERSONAL_INFO_CLOSE_BTN: 'personal_info_close_btn',
  PERSONAL_INFO_DROPDOWN: 'personal_info_dropdown',
  GROUPS: 'groups',
  NEW_POST: 'new_post',
  LIVE_STREAM: 'live_stream'
};

export const TABS_TO_SHOW_WHEN_PENDING_CREATOR: string[] = [
  SIDEBAR_TABS.HOME,
  SIDEBAR_TABS.ACTIVITY,
  SIDEBAR_TABS.MESSAGES,
  SIDEBAR_TABS.NOTIFICATIONS,
  SIDEBAR_TABS.CREATORS,
  SIDEBAR_TABS.MONETIZE,
  SIDEBAR_TABS.WALLET,
  SIDEBAR_TABS.INSIGHTS,
  SIDEBAR_TABS.RESOURCES,
  SIDEBAR_TABS.CREATE_ON_TOPFANS,
  SIDEBAR_TABS.WELCOME_MESSAGE,
  SIDEBAR_TABS.CREATOR_TYPE,
  SIDEBAR_TABS.TOPIC_TAGS,
  SIDEBAR_TABS.BADGES,
  SIDEBAR_TABS.DELEGATION,
  SIDEBAR_TABS.NFT_WALLET,
  SIDEBAR_TABS.PRIVACY_AND_PASSWORD,
  SIDEBAR_TABS.SEARCH,
  SIDEBAR_TABS.GAMIFICATION,
  SIDEBAR_TABS.PROFILE_NAV,
  SIDEBAR_TABS.PERSONAL_INFO_CLOSE_BTN,
  SIDEBAR_TABS.PERSONAL_INFO_DROPDOWN,
  SIDEBAR_TABS.GROUPS,
  SIDEBAR_TABS.INTERESTS,
];

export const TABS_TO_SHOW_WHEN_APPROVED_CREATOR: string[] = [
  SIDEBAR_TABS.HOME,
  SIDEBAR_TABS.ACTIVITY,
  SIDEBAR_TABS.MESSAGES,
  SIDEBAR_TABS.NOTIFICATIONS,
  SIDEBAR_TABS.CREATORS,
  SIDEBAR_TABS.MONETIZE,
  SIDEBAR_TABS.WALLET,
  SIDEBAR_TABS.INSIGHTS,
  SIDEBAR_TABS.RESOURCES,
  SIDEBAR_TABS.CREATE_ON_TOPFANS,
  SIDEBAR_TABS.WELCOME_MESSAGE,
  SIDEBAR_TABS.CREATOR_TYPE,
  SIDEBAR_TABS.TOPIC_TAGS,
  SIDEBAR_TABS.BADGES,
  SIDEBAR_TABS.DELEGATION,
  SIDEBAR_TABS.NFT_WALLET,
  SIDEBAR_TABS.PRIVACY_AND_PASSWORD,
  SIDEBAR_TABS.SEARCH,
  SIDEBAR_TABS.GAMIFICATION,
  SIDEBAR_TABS.PROFILE_NAV,
  SIDEBAR_TABS.PERSONAL_INFO_CLOSE_BTN,
  SIDEBAR_TABS.PERSONAL_INFO_DROPDOWN,
  SIDEBAR_TABS.GROUPS,
  SIDEBAR_TABS.NEW_POST,
  SIDEBAR_TABS.LIVE_STREAM,
  SIDEBAR_TABS.PROFILE,
  SIDEBAR_TABS.INTERESTS,
  SIDEBAR_TABS.LINK_IN_BIO,
  SIDEBAR_TABS.OUTBOUND_EMAILS
];